import HideRexOutlineSVG from './icon_hide_rex_outline.svg';
import withIconProps from './withIconProps';

export default withIconProps(HideRexOutlineSVG);
